import { useOutletContext } from 'react-router-dom'
import { TRelatorioAusencias } from '@acme/core'

export function useAusenciasOutletContext() {
    return useOutletContext<{
        data?: TRelatorioAusencias[]
        competencia: string
    }>()
}
